<lib-fo-toolbar-sidebar #toolbarSidebar [isSidebarOnToolbar]="true" [isLandingPage]="true" [isDisableLogBook]="true"
  [isShowMenuButton]="false">
  <div class="page-container">
    <div class="status-card">

      <div class="card-header">
        <h1 class="hotel-title">{{ hotelName }}</h1>
        <div class="meta-wrapper">
          <div class="date-badge">
            <span class="material-icons icon-xs">calendar_today</span>
            Closeday Process
          </div>
        </div>
      </div>

      <div class="card-body">
        <div *ngIf="!closedayInProgress" class="empty-state">
          <div class="icon-circle">
            <span class="material-icons">store</span>
          </div>
          <p class="status-text">System is ready</p>
        </div>

        <div *ngIf="closedayInProgress" class="process-wrapper">

          <div class="operator-info" *ngIf="closedayBy">
            <span class="material-icons icon-sm">manage_accounts</span>
            <span>Operated by: <strong>{{ closedayBy }}</strong></span>
          </div>

          <ul class="timeline">
            <li *ngFor="let step of stateMessages | keyvalue: originalOrder" [class]="getStepStatus(step.key)">

              <div class="timeline-marker">
                <span *ngIf="getStepStatus(step.key) === 'completed'" class="material-icons check-icon">check</span>

                <div *ngIf="getStepStatus(step.key) === 'current'" class="spinner-loader"></div>

                <div *ngIf="getStepStatus(step.key) === 'pending'" class="pending-dot"></div>
              </div>

              <div class="timeline-content">
                <span class="step-label">{{ step.value }}</span>
              </div>
            </li>
          </ul>
        </div>
        <div class="reset-btn-container">
          <button mat-button class="reset-btn" (click)="cancelCloseDayClick()" *ngIf="allowCancel && notFirstLoad">Reset</button>
        </div>
      </div>
    </div>
  </div>
</lib-fo-toolbar-sidebar>